// Übersicht eines sonstigen Kontakts (Handoff Sonstige Kontakte §2, Screen 05): Widgets „Stammdaten“ und „Details“.
// Felder wie bisher in KontaktUebersicht (Generic-Zweig); leere Pflichtzeilen zeigen „—“ wie im Prototyp,
// Mobil/Festnetz/Adresse nur, wenn vorhanden. „Telefon“ = Hauptnummer aus kontakte_unified (Handy, sonst Festnetz) –
// eine Spalte telefon gibt es in kontakte nicht (bisher stand dort immer „—“).
import { ZustellwegeAuswahl } from '../../../../components/schreiben/ZustellwegeAuswahl';
import { Briefcase, User, type Icon } from '@phosphor-icons/react';
import type { SonstigerKontaktZeile } from '../../../../lib/kontakte/useSonstigerKontakt';

interface Zeile { label: string; wert: string | null | undefined; voll?: boolean }

function Widget({ titel, icon: I, farbe, zeilen }: { titel: string; icon: Icon; farbe: number; zeilen: Zeile[] }) {
  const b = `var(--sk-av-${farbe}-b)`;
  return (
    <section aria-label={titel} className="sk-glas sk-widget relative flex flex-col"
      style={{ isolation: 'isolate', overflow: 'hidden', borderRadius: 26, padding: 18, gap: 14 }}>
      <div aria-hidden className="pointer-events-none absolute inset-0" style={{ zIndex: -1, background: `radial-gradient(90% 70% at 100% 0%, color-mix(in srgb, ${b} 14%, transparent), transparent 60%)` }} />
      <I aria-hidden weight="duotone" size={150} className="pointer-events-none absolute" style={{ right: -22, bottom: -30, zIndex: -1, color: b, opacity: 0.1, transform: 'rotate(-12deg)' }} />
      <h2 className="m-0 flex items-center" style={{ gap: 10, fontSize: 15, fontWeight: 800 }}>
        <span aria-hidden className="flex items-center justify-center"
          style={{ width: 32, height: 32, borderRadius: 10, color: 'var(--sk-av-ink)', background: `linear-gradient(155deg, var(--sk-av-${farbe}-a), ${b})`, boxShadow: `inset 0 1px 0 rgba(255,255,255,0.45), 0 6px 12px -6px ${b}` }}>
          <I weight="fill" size={16} />
        </span>
        {titel}
      </h2>
      <dl className="m-0 grid" style={{ gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: 8 }}>
        {zeilen.map((z, i) => (
          <div key={`${z.label}-${i}`} className="flex min-w-0 flex-col"
            style={{ gridColumn: z.voll ? '1 / -1' : 'auto', padding: '10px 12px', borderRadius: 14, background: 'var(--fill)', gap: 3 }}>
            <dt style={{ fontSize: 10.5, fontWeight: 800, letterSpacing: '0.05em', textTransform: 'uppercase', color: 'var(--ink3)' }}>{z.label}</dt>
            <dd className="m-0" style={{ fontSize: 13.5, fontWeight: 700, color: z.wert ? 'var(--ink)' : 'var(--ink3)', overflowWrap: 'anywhere' }}>{z.wert || '—'}</dd>
          </div>
        ))}
      </dl>
    </section>
  );
}

export function SonstigeUebersicht({ zeile: d, telefon }: { zeile: SonstigerKontaktZeile; telefon: string | null }) {
  const adresse = [
    [d.strasse, d.hausnummer].filter(Boolean).join(' '),
    [d.plz, d.stadt].filter(Boolean).join(' '),
  ].filter(Boolean).join(', ');

  const stamm: Zeile[] = [
    { label: 'Vorname', wert: d.vorname },
    { label: 'Nachname', wert: d.nachname },
    { label: 'Firma', wert: d.firma_name },
    { label: 'E-Mail', wert: d.email },
    { label: 'Telefon', wert: telefon },
  ];
  if (d.mobil) stamm.push({ label: 'Mobil', wert: d.mobil });
  if (d.handynummer) stamm.push({ label: 'Mobil', wert: d.handynummer });
  if (d.festnetz) stamm.push({ label: 'Festnetz', wert: d.festnetz });
  if (adresse) stamm.push({ label: 'Adresse', wert: adresse, voll: true });

  return (
    <div className="grid items-start" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 320px), 1fr))', gap: 12 }}>
      <Widget titel="Stammdaten" icon={User} farbe={0} zeilen={stamm} />
      <Widget titel="Details" icon={Briefcase} farbe={1} zeilen={[
        { label: 'Typ', wert: d.typ },
        { label: 'Unternehmensart', wert: d.unternehmensart },
        { label: 'Kontaktart', wert: d.kontaktart },
      ]} />
      <div style={{ gridColumn: '1 / -1' }}><ZustellwegeAuswahl art="kontakt" id={d.id} /></div>
    </div>
  );
}
